import React, { FC, useEffect, useState } from 'react';
import AcademyProductTemplate from '@components/AcademyProduct2/AcademyProduct';
import EventTemplate from '@components/Event/Event';
import useTranslation from '@hooks/useTranslation';
import { IAcademyItem2, ITrainingItem } from '../../interfaces/Calendar';
import ContentWrapper from '../../ui/Content/Content';
import { EmptyMessage, Wrapper, ShowMore } from './AcademyProducts.elements';
import ButtonTemplate from '@ui/Button/Button';
import SpinnerTemplate from '@ui/Spinner/Spinner';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { calendarApi } from '../../services/calendar.service';

interface AcademyProductsProps {
    events: IAcademyItem2[];
    eventsCount: number;
    // courses: ITrainingItem[];
    //coursesCount: number;
}

const AcademyProductsTemplate: FC<AcademyProductsProps> = ({ events, eventsCount }) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [poduajtia, setPodujatia] = useState(null);
    const [totalCount, setTotalCount] = useState(null);

    const showMore = async () => {
        setIsLoading(true);

        const { data } = await calendarApi.getAcademies(
            5
            , poduajtia.length
        );
        setPodujatia([...poduajtia, ...data?.results]);
        setTotalCount(data?.total_count)

        setIsLoading(false);
    };

    useEffect(() => {
        if (events.length > 0) {
            setPodujatia(events);
            setTotalCount(eventsCount)
        }
    }, [events]);

    return (
        <ContentWrapper withPadding mobileSidePadding={20}>
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('academy.trainings.title')}
            </TitleTemplate>
            {totalCount > 0 ? (
                <Wrapper>
                    {[...poduajtia]
                        ?.map((event, key) => {

                            return <AcademyProductTemplate event={event as IAcademyItem2} key={key} />;

                        })}

                    {poduajtia?.length < totalCount && (
                        <ShowMore>
                            {isLoading ? (
                                <SpinnerTemplate size={32} />
                            ) : (
                                <ButtonTemplate
                                    marginTop={30}
                                    whiteType
                                    onClick={showMore}
                                    text={t('homepage.calendar.button.more')}
                                />
                            )}
                        </ShowMore>
                    )}
                </Wrapper>
            ) : (
                <EmptyMessage>{t('academy.trainings.emptyMessage')}</EmptyMessage>
            )}
        </ContentWrapper>
    );
};
export default AcademyProductsTemplate;
